module.exports = __webpack_public_path__ + "static/furniture-featured-categories-section-code-a6e83da93ef27aaa1ac3e0695552bbdd.png";